import { useRef } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $reportStore } from '@lib/store';
import { useOutsideClick } from '@shared/hooks';
import { FileUtils } from '@shared/utils';
import { Button, Icon, Text } from '@shared/widgets';
import CloseIcon from '@assets/icons/close.svg';
import ConfirmIcon from '@assets/icons/confirm.svg';

interface IGeneratedModalProps {
  open: boolean;
  onClose: () => void;
}

export const GeneratedFileModal = (props: IGeneratedModalProps) => {
  const reportStore = useUnit($reportStore.store);

  const ref = useRef<HTMLDivElement>(null);

  const { t } = useTranslation('reports');

  const closeHandler = () => {
    $reportStore.events.clear();
    props.onClose();
  };
  useOutsideClick(ref, closeHandler);

  const clickHereHandler = () => {
    if (!reportStore.data?.data) return;
    FileUtils.downloadFile(reportStore.data);
  };

  if (!props.open) return null;
  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div
        ref={ref}
        className='relative flex h-full max-h-[300px] w-full max-w-[378px] flex-col items-center gap-6 bg-ice px-[50px] py-[72px] shadow-lg dark:bg-eerie-black'
      >
        <Button className='absolute right-6 top-6' color='icon' onClick={props.onClose}>
          <Icon icon={<CloseIcon />} />
        </Button>
        <Icon icon={<ConfirmIcon />} className='flex h-12 w-12 shrink-0 items-center justify-center' color='primary' />
        <div className='flex flex-col items-center gap-2'>
          <Text weight='semibold' size='2xl'>
            {t('modals.generatedFile.title')}
          </Text>
          <Text className='text-center'>
            {t('modals.generatedFile.description')}
            <span className='cursor-pointer text-primary' onClick={clickHereHandler}>
              {t('modals.generatedFile.clickHere')}
            </span>
          </Text>
        </div>
      </div>
    </div>
  );
};
